import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountApi from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { fetchAlertPreferencesDone, fetchAlertPreferencesError, setAlertPreferencesDone, setAlertPreferencesError, setAlertChannelDone, setAlertChannelError } from './actionCreators';
import { FETCH_ALERT_PREFERENCES, SET_ALERT_PREFERENCES, SET_ALERT_CHANNEL } from './actionTypes';
import { logout } from '../auth/actionCreators';
function* getAlertNotification(constAccessParams) {
    const user = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountApi.getAlertPreferences, user);
    if (isSuccessResponse(result)) {
        yield put(fetchAlertPreferencesDone(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(fetchAlertPreferencesError(result));
    }
}
export function* watchGetAlertNotificationCalls(constAccessParams) {
    yield takeLatest(FETCH_ALERT_PREFERENCES, getAlertNotification, constAccessParams);
}
function* setAlertNotification(constAccessParams, action) {
    const user = yield call(checkUserHelper, constAccessParams);
    const { minutes, alerts } = action.data;
    const result = yield call(HeroAccountApi.setAlertPreferences, user, minutes, alerts);
    if (isSuccessResponse(result)) {
        yield put(setAlertPreferencesDone());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(setAlertPreferencesError(result));
    }
}
export function* watchSetAlertNotificationCalls(constAccessParams) {
    yield takeLatest(SET_ALERT_PREFERENCES, setAlertNotification, constAccessParams);
}
function* setAlertChannel(constAccessParams, action) {
    const user = yield call(checkUserHelper, constAccessParams);
    const { warning_after_15_min_channel } = action.data;
    const result = yield call(HeroAccountApi.set15MinAlertChannel, user, warning_after_15_min_channel);
    if (isSuccessResponse(result)) {
        yield put(setAlertChannelDone(action.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(setAlertChannelError(result));
    }
}
export function* watchSetAlertChannelCalls(constAccessParams) {
    yield takeLatest(SET_ALERT_CHANNEL, setAlertChannel, constAccessParams);
}
//# sourceMappingURL=saga.js.map